export enum PreferenceThemeSlugsEnum {
  CLEAN = "CLEAN",
  HEART = "HEART",
  MAGIC = "MAGIC",
  MARS = "MARS",
  MINT = "MINT",
  OCEAN = "OCEAN",
  SUN = "SUN",
}

export const PreferenceThemeColorsEnum = {
  CLEAN: "#0D6EDE",
  HEART: "#E56688",
  MAGIC: "#B773E7",
  MARS: "#E69305",
  MINT: "#21BA78",
  OCEAN: "#57A5FF",
  SUN: "#FFDE05",
};

export const PreferenceSecondaryColorsEnum = {
  CLEAN: "#171717",
};
